import type { Organization } from "@/models/organization"
import type {
  BillListApiQueryOptions,
  BillListResponse,
} from "@/services/core-api/types"
import { httpClient, toHttpError } from "@/utils/api"

export interface GetBillsParams {
  apiQueryOptions: BillListApiQueryOptions
  organizationId: Organization["id"]
}

export const getBills = async ({
  apiQueryOptions,
  organizationId,
}: GetBillsParams): Promise<BillListResponse> => {
  try {
    const response = await httpClient.get<BillListResponse>(
      `/api/v1/organizations/${organizationId}/bills`,
      {
        params: apiQueryOptions,
      }
    )

    return response.data
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}
